module.exports = __webpack_public_path__ + "img/add-square.55789b18.svg";